(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/keno-draw.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/keno-draw.js');

'use strict';

const productMapping = svs.numbergames.productMapping;

class KenoDraw extends svs.numbergames.draws.Draw {
  constructor() {
    super({
      productDrawId: productMapping.getProductDrawId(productMapping.CONSTANTS.KENO),
      daysBetweenDraws: 1
    });
  }
}
svs.numbergames.draws.KenoDraw = KenoDraw;

 })(window);